import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import classes from './Sider.module.scss';

import FAQs from './FAQs';
import AboutUs from './AboutUs';
import Language from './Language';
import Setting from './Settings';
import SignupOrLogin from './SignupOrLogin';
import Logout from './Logout';
import TermsOfServices from './TermsOfServices';

export default function Sider({ isClosing }) {
  const isLogedIn = useSelector((state) => state.authentication.isLogedIn);

  const { t, i18n } = useTranslation('sider');
  const language = i18n.language;

  return (
    <section
      className={`${classes.sider} ${
        isClosing ? classes.closingAnimation : ''
      }`}
    >
      <ul className={classes['sider-countainer']}>
        <ul className={classes.question}>
          <li className={classes['item-countainer']}>
            <FAQs language={language} text={t('FAQs')} />
          </li>
          <li className={classes['item-countainer']}>
            <AboutUs language={language} text={t('About us')} />
          </li>
        </ul>
        <ul className={classes.setting}>
          <li className={classes['item-countainer']}>
            <Language language={language} text={t('Language')} i18n={i18n} />
          </li>
          <li className={classes['item-countainer']}>
            <Setting language={language} text={t('Settings')} />
          </li>
          <li className={classes['item-countainer']}>
            {!isLogedIn && (
              <SignupOrLogin language={language} text={t('Sign up / Log in')} />
            )}
            {/* فرق میکند :) */}
            {isLogedIn && <Logout language={language} text={'Log out'} t={t} />}
          </li>
        </ul>
      </ul>
      {/* <span className={classes.terms}>{t('Terms of Services')}</span> */}
      <TermsOfServices
        language={language}
        text={t('Terms of Services')}
        t={t}
      />
    </section>
  );
}
